<template>
  <div class="intranet">
    <!-- Toolbar -->
    <F2gToolbar
      :showPersonalizationChanged="changeShowPersonalizationColors"
      @cardOpened="(boolean) => (cardOpened = boolean)"
    />
    <!-- Page Content -->
    <v-container @click="checkClick">
      <router-view :class="marginBarActions" />
    </v-container>
    <!-- bottom bar actions -->
    <bottom-bar-actions
      @changeVisibility="(value) => (showBottomBarActions = value)"
    />
    <!-- PopUp token expired -->
    <PopUpLogin></PopUpLogin>
  </div>
</template>

<script>
import F2gToolbar from "@/flit2go-web-core/components/layout/toolbar/f2g-toolbar.vue";
import PopUpLogin from "@/flit2go-web-core/components/layout/popUp-Login.vue";
import BottomBarActions from "@/flit2go-web-core/components/layout/bottom-bar-actions";
import { EventBus } from "@/flit2go-web-core/util/event-bus.js";
import { mapGetters } from "vuex";

export default {
  name: "IntranetWrapper",
  components: {
    F2gToolbar,
    BottomBarActions,
    PopUpLogin,
  },
  data: () => ({
    hideCards: false,
    cardOpened: false,
    showBottomBarActions: false,
    changeShowPersonalizationColors: false,
  }),
  computed: {
    ...mapGetters({
      userData: "auth/getUserProfile",
      ownerColors: "auth/getOwnerColors",
    }),
    marginBarActions() {
      return this.showBottomBarActions ? "pb-80" : "";
    },
  },
  created() {
    EventBus.$on("actions", (value) => {
      this.showBottomBarActions =
        null !== value && value.buttons && value.buttons.length > 0;
    });
  },
  methods: {
    checkClick() {
      if (this.cardOpened) {
        this.cardOpened = false;
        this.hideCards = true;
        setTimeout(() => (this.hideCards = false), 2000);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.intranet {
  width: 100%;
  min-height: 100vh;
  background-color: #f5f6fa;

  .container {
    min-height: calc(100vh - 64px);
    padding: 0px;
    max-width: 100vw;
    padding-top: 60px;
  }
}

//Chart js
.chartjs-render-monitor {
  max-height: calc(100% - 90px);
}

#line-chart {
  max-width: calc(100% - 30px);
}

.pb-80 {
  padding-bottom: 80px;
}
</style>
